import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../../utils/cn';
import Icon from '../../ui/Icon';
import { COLORS } from '../../ui/ui.constants';
import styles from './ToastBody.module.scss';

const faIcon = {
  error: 'fa-times',
  info: 'fa-info',
  success: 'fa-check',
  warning: 'fa-exclamation-triangle'
};

function SquareIcon({ msgType }) {
  return (
    <div className={`${styles.iconContainer} ${styles[msgType]}`}>
      <i aria-label={`${msgType} message`} className={`fa ${faIcon[msgType]}`} />
    </div>
  );
}

SquareIcon.propTypes = {
  msgType: PropTypes.string.isRequired
};

function CircleIcon({ msgType }) {
  if (msgType === 'success') {
    return (
      <span
        className={cn(
          'tw-shrink-0 tw-flex tw-items-center tw-justify-center',
          'tw-w-5 tw-h-5 tw-rounded-full tw-bg-green',
        )}
      >
        <Icon color="white" icon="Checkmark" size={16} />
      </span>
    );
  }

  // Info is not an alarm — without this it fell through to the red warning icon below.
  if (msgType === 'info') {
    return <Icon className="tw-shrink-0" color={COLORS['tci-black']} icon="InfoAlternate" size={20} />;
  }

  return <Icon className="tw-shrink-0" color={COLORS.red} icon="Warning" size={24} />;
}

CircleIcon.propTypes = {
  msgType: PropTypes.string.isRequired
};

export default function ToastBody({ body, heading, iconStyle, msgType }) {
  function renderMessage() {
    return (
      <div className={cn(styles.messageContainer, { [styles.circleStyling]: iconStyle === 'circle' })}>
        <div>
          {
            heading.length > 0 &&
            <div className={styles.heading}>{heading}</div>
          }
          <div>{body}</div>
        </div>
      </div>
    );
  }

  if (iconStyle !== 'circle') {
    return (
      <div className={styles.container}>
        <SquareIcon msgType={msgType} />
        {renderMessage()}
      </div>
    );
  }

  return (
    <span className="tw-flex tw-items-center tw-gap-3 tw-text-sm">
      <CircleIcon msgType={msgType} />
      <span>{renderMessage()}</span>
    </span>
  );
}

ToastBody.propTypes = {
  body: PropTypes.node.isRequired,
  heading: PropTypes.string,
  iconStyle: PropTypes.string,
  msgType: PropTypes.string
};

ToastBody.defaultProps = {
  heading: '',
  iconStyle: 'square',
  msgType: 'success'
};
